import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  Button,
  Header,
  Modal,
} from 'semantic-ui-react';
import { withTranslation } from 'react-i18next';
import LoadImage from '../../components/LoadImage';
import { TRANSLATION_FILES } from '../../constants/translation';

class RemoveLogo extends Component {
  static contextTypes = {
    store: PropTypes.object,
  }
  static propTypes = {
    open: PropTypes.bool,
    onClose: PropTypes.func,
    onConfirm: PropTypes.func,
    picture: PropTypes.shape({
      key: PropTypes.string,
    }),
    data: PropTypes.shape({
      name: PropTypes.string,
    }),
    headerNode: PropTypes.node,
    pictureSize: PropTypes.number,
    extension: PropTypes.string,
    t: PropTypes.func,
  }
  static defaultProps = {
    pictureSize: 30,
  }
  shouldComponentUpdate(nextProps) {
    if ((JSON.stringify(this.props.picture) !== JSON.stringify(nextProps.picture)) ||
    (JSON.stringify(this.props.data) !== JSON.stringify(nextProps.data)) ||
    (this.props.open !== nextProps.open)) {
      return true;
    }
    return false;
  }
  handleOnClose = (e) => {
    if (this.props.onClose) {
      this.props.onClose(e);
    }
  }
  handleOnComfirm = (e) => {
    e.preventDefault();
    if (this.props.onConfirm) {
      this.props.onConfirm(e);
    }
  }
  renderWarning() {
    const { picture, t } = this.props;
    if (picture && picture.projects) {
      const projectLength = picture.projects ? picture.projects.length : 0;
      return (
        <h3>{t('This {{section}} is used in {{count}} place(s).', { section: t('Logo'), count: projectLength })}</h3>
      );
    }
    return null;
  }
  render() {
    const { t } = this.props;
    return (
      <Modal
        basic
        open={this.props.open === true}
        onClose={this.handleOnClose}
      >
        <Header icon="warning sign" content={`${t(this.props.headerNode || 'Confirm delete')}?`} />
        <Modal.Content image>
          <LoadImage
            wrapped
            picture={this.props.picture}
            pictureSize={this.props.pictureSize}
            extension={this.props.extension}
          />
          <Modal.Description>
            {this.renderWarning()}
            <h3>{t('Are you sure to delete this logo')}?</h3>
          </Modal.Description>
        </Modal.Content>
        <Modal.Actions>
          <Button basic negative onClick={this.handleOnClose} icon="cancel" content={t('No')} inverted />
          <Button basic positive onClick={this.handleOnComfirm} icon="trash" content={t('Yes')} inverted />
        </Modal.Actions>
      </Modal>
    );
  }
}

export default withTranslation(TRANSLATION_FILES.screens)(RemoveLogo);



// WEBPACK FOOTER //
// ./src/containers/modals/RemoveLogo.jsx